import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { LinkProjectPricingProfile } from './LinkProjectPricingProfile';

interface IProps {
  projectId: number;
}

export const LinkProjectPricingProfileButton = ({ projectId }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        text={t('buttonLabelAddProjectPricingProfile')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <LinkProjectPricingProfile
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        projectId={projectId}
      />
    </>
  );
};
